import { ContentFragment, InvalidContentError, isContentFragment } from '@oneaudi/falcon-tools';

export interface FalconContent extends Partial<ContentFragment> {
  __type: 'aem-headless';
  fields: {
    is360ViewEnabled: boolean;
    cta360ViewButtonLabel: string;
  };
}

export interface AppContent {
  __type?: 'default';
  is360ViewEnabled: boolean;
  cta360ViewButtonLabel: string;
}

function isFalconContent(content: unknown): content is FalconContent {
  // Check here for all required fields and return true, otherwise false
  return Boolean(isContentFragment(content));
}

export const mapContent = (content: AppContent | FalconContent): AppContent => {
  // if (content?.__type === 'aem-headless') {
  //   // Perform runtime validation
  //   if (!isFalconContent(content)) {
  //     // Throw `InvalidContentError` here if provided content
  //     // is not valid. This will display as a special error message
  //     // in the frontend on author environments.
  //     throw new InvalidContentError('Content is invalid.');
  //   }

  //   // map CF content to internal structure
  //   return normalizeContent(content);
  // }
  // return { ...content };

  if (content?.__type !== 'aem-headless') {
    return { ...content };
  }

  return normalizeContent(content);
};

const normalizeContent = (content: FalconContent): AppContent => {
  const { is360ViewEnabled, cta360ViewButtonLabel } = content.fields;

  const formattedContent = {
    is360ViewEnabled,
    cta360ViewButtonLabel,
  };

  return formattedContent;
};
